// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('discountManagement', {
        url: '/discountManagement',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/discountManagement/discountManagement.tpl.html',
        controller: 'MainDiscountManagementController as vm'
    });
}

// @ngInject
function MainDiscountManagementController(){
    var vm = this;
}

angular
    .module('main.discountManagement', ['discountManagement.discounts'])
    .config(stateConfig)
    .controller('MainDiscountManagementController', MainDiscountManagementController);